import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.chatbot');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-chatbot',
template: templateSource || '',
    styles: [`

/* file: /Users/ijaemun/Documents/Codex/2026-09-30/task/migration-prep/mac-candidate-build/src/app/page.chatbot/view.scss */
:host {
  display: block;
  height: 100%;
}

.report-source {
  flex-shrink: 0;
  min-width: 0;
  overflow: hidden;
  background: #ffffff;
}

.report-source-toolbar,
.report-source-actions,
.report-source-scope,
.report-source-path,
.report-source-folder-row,
.report-source-folder-meta,
.report-source-document-row {
  display: flex;
  align-items: center;
}

.report-source-toolbar {
  min-width: 0;
  justify-content: space-between;
  gap: 10px;
  padding-right: 12px;
  background: #ffffff;
  border-bottom: 1px solid #edf1f5;
}

.report-source-actions {
  flex: 0 0 auto;
  gap: 6px;
}

.report-source-scope {
  flex: 0 0 auto;
  gap: 2px;
  padding: 2px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
}

.report-source-scope-button {
  min-height: 24px;
  padding: 3px 8px;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
  background: transparent;
  border: 0;
  border-radius: 4px;
}

.report-source-scope-button:hover:not(:disabled) {
  color: #334155;
}

.report-source-scope-button.is-active {
  color: #2563eb;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
}

.report-source-scope-button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.report-source-quota {
  flex: 0 0 auto;
  color: #475569;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}

.report-source-quota.is-exceeded {
  color: #b91c1c;
}

.report-source-action,
.report-source-scope-button,
.report-source-path button {
  box-sizing: border-box;
  font-family: inherit;
  cursor: pointer;
}

.report-source-action {
  min-height: 30px;
  padding: 5px 10px;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
}

.report-source-action:hover {
  color: #0f172a;
  background: #f8fafc;
  border-color: #94a3b8;
}

.report-source-action:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.report-source-path {
  min-width: 0;
  flex: 1 1 auto;
  gap: 5px;
  min-height: 35px;
  padding: 6px 16px;
  overflow-x: auto;
  color: #94a3b8;
  background: #ffffff;
  white-space: nowrap;
}

.report-source-path button {
  max-width: 180px;
  padding: 2px 0;
  overflow: hidden;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: transparent;
  border: 0;
}

.report-source-path button:hover {
  color: #2563eb;
}

.report-source-path-separator {
  flex: 0 0 auto;
  color: #cbd5e1;
}

.report-source-list {
  box-sizing: border-box;
  padding-top: 10px;
  overflow: visible;
}

.report-source-selection-tools {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: #f8fafc;
  border-bottom: 1px solid #dbe4ee;
}

.report-source-selection-count {
  flex: 0 0 auto;
  color: #475569;
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.report-source-selection-action {
  min-height: 25px;
  padding: 3px 8px;
  color: #475569;
  font: inherit;
  font-size: 10px;
  font-weight: 700;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  cursor: pointer;
}

.report-source-selection-action.is-primary {
  color: #2563eb;
  border-color: #bfdbfe;
}

.report-source-selection-action:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.report-source-page-content {
  box-sizing: border-box;
  overflow: hidden;
}

.report-source-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 38px;
  padding: 6px 14px;
  border-top: 1px solid #edf1f5;
}

.report-source-pagination button {
  min-width: 54px;
  min-height: 27px;
  padding: 4px 9px;
  color: #475569;
  font: inherit;
  font-size: 10px;
  font-weight: 700;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  cursor: pointer;
}

.report-source-pagination button:hover:not(:disabled) {
  color: #2563eb;
  border-color: #93c5fd;
}

.report-source-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.35;
}

.report-source-page-status {
  min-width: 132px;
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
}

.report-source-empty {
  padding: 42px 18px;
  color: #94a3b8;
  font-size: 11px;
  text-align: center;
}

.report-source-empty.is-error {
  color: #b91c1c;
}

.report-source-folder-row {
  width: 100%;
  min-height: 38px;
  gap: 8px;
  padding: 6px 14px;
  color: inherit;
  font-family: inherit;
  text-align: left;
  background: #ffffff;
  border: 0;
  border-bottom: 1px solid #edf1f5;
  cursor: pointer;
}

.report-source-folder-row:hover {
  background: #f8fafc;
}

.report-source-folder-row:focus-visible {
  position: relative;
  outline: 2px solid #2563eb;
  outline-offset: -2px;
}

.report-source-folder-icon {
  flex: 0 0 32px;
  width: 32px;
  color: #ca8a04;
  font-size: 14px;
  line-height: 1;
  text-align: center;
}

.report-source-folder-name {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  color: #2563eb;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-source-folder-meta {
  flex: 0 0 auto;
  gap: 9px;
  color: #64748b;
  font-size: 10px;
  white-space: nowrap;
}

.report-source-folder-arrow {
  flex: 0 0 auto;
  color: #94a3b8;
  font-size: 18px;
  line-height: 1;
}

.report-source-document-row {
  min-height: 38px;
  gap: 8px;
  padding: 6px 14px;
  background: #ffffff;
  border-bottom: 1px solid #edf1f5;
  cursor: pointer;
}

.report-source-document-row:hover {
  background: #f8fafc;
}

.report-source-document-row input {
  flex: 0 0 auto;
  width: 14px;
  height: 14px;
  margin: 0;
  accent-color: #2563eb;
}

.report-source-extension {
  flex: 0 0 32px;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
  text-align: center;
}

.report-source-extension[data-extension=PDF] {
  color: #ef4444;
}

.report-source-extension[data-extension=HWP],
.report-source-extension[data-extension=HWPX] {
  color: #8b5cf6;
}

.report-source-document-name {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  color: #334155;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-source-document-size,
.report-source-document-role,
.report-source-unavailable {
  flex: 0 0 auto;
  font-size: 10px;
  white-space: nowrap;
}

.report-source-document-size {
  color: #94a3b8;
}

.report-source-document-role {
  padding: 1px 5px;
  color: #64748b;
  font-weight: 800;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
}

.report-source-document-role[data-role=report] {
  color: #2563eb;
  background: #eff6ff;
  border-color: #bfdbfe;
}

.report-source-document-role[data-role=contract] {
  color: #7e22ce;
  background: #faf5ff;
  border-color: #e9d5ff;
}

.report-source-document-role[data-role=kickoff] {
  color: #15803d;
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.report-source-document-role[data-role=ledger] {
  color: #0f766e;
  background: #f0fdfa;
  border-color: #99f6e4;
}

.report-source-unavailable {
  color: #b91c1c;
}

.report-source-retro {
  border: 1px solid #9eb4c7;
  border-top: 0;
  border-bottom: 0;
  border-radius: 0;
}

.report-source-retro .report-source-folder-name {
  color: #003366;
}

.report-source-retro .report-source-scope,
.report-source-retro .report-source-scope-button {
  border-radius: 1px;
}

.report-source-retro .report-source-scope-button.is-active {
  color: #ffffff;
  background: #003366;
  box-shadow: none;
}

.report-source-retro .report-source-action,
.report-source-retro .report-source-extension {
  border-radius: 1px;
}

.report-source-retro .report-source-path button:hover {
  color: #003366;
}

.report-evaluation-action {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 18px;
}

.report-evaluation-button {
  box-sizing: border-box;
  min-width: 178px;
  min-height: 38px;
  padding: 8px 18px;
  color: #475569;
  font-family: inherit;
  font-size: 12px;
  font-weight: 800;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  cursor: pointer;
}

.report-evaluation-button:hover:not(:disabled) {
  color: #0f172a;
  background: #f8fafc;
  border-color: #94a3b8;
}

.report-evaluation-button.has-documents {
  color: #ffffff;
  background: #2563eb;
  border-color: #2563eb;
}

.report-evaluation-button.has-documents:hover:not(:disabled) {
  color: #ffffff;
  background: #1d4ed8;
  border-color: #1d4ed8;
}

.report-evaluation-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.report-start-retro {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #cccccc;
}

.report-evaluation-action-retro .report-evaluation-button {
  color: #003366;
  border-color: #99b3cc;
  border-radius: 1px;
}

.report-evaluation-action-retro .report-evaluation-button.has-documents {
  color: #ffffff;
  background: #003366;
  border-color: #001a33;
}

.chatbot-start-page {
  min-height: 0;
  overflow: hidden;
}

.chatbot-start-page.has-history,
.legacy-roomy-controls.has-history {
  gap: 16px;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  padding: 10px !important;
}

.chatbot-start-inspection {
  height: 100%;
  max-height: 100%;
}

.chatbot-start-page.has-history .chatbot-start-inspection {
  flex: 1 1 auto;
  max-width: none !important;
}

.chatbot-start-card {
  height: 100%;
  min-height: 0;
}

.chatbot-start-history {
  width: clamp(320px, 18vw, 365px);
  height: 100%;
  max-height: 100%;
  min-width: 0;
}

.legacy-roomy-controls .chatbot-start-history {
  flex: 0 0 clamp(320px, 18vw, 365px);
}

.legacy-roomy-controls.has-history > div:not(.chatbot-start-history) {
  flex: 1 1 auto;
  width: auto !important;
  max-width: none !important;
  min-width: 0 !important;
}

.legacy-roomy-controls .roomy-button,
.legacy-roomy-controls td > button {
  box-sizing: border-box;
  min-height: 22px;
  padding: 3px 9px !important;
  line-height: 1.35;
}
.legacy-roomy-controls .roomy-badge,
.legacy-roomy-controls td > span {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 2px 7px !important;
  line-height: 1.35;
}

.history-title,
.history-summary {
  min-width: 0;
  overflow: hidden;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.history-title {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.history-summary {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.35;
}

.chatbot-history-modal {
  background: rgba(15, 23, 42, 0.36);
  backdrop-filter: blur(2px);
}

.chatbot-history-dialog {
  min-height: min(620px, 100vh - 48px);
  max-height: min(82vh, 720px);
}

.chatbot-history-list {
  overscroll-behavior: contain;
}

@media (min-width: 768px) {
  .chatbot-history-modal {
    display: none !important;
  }
}
@media (max-width: 767px) {
  .chatbot-start-page {
    align-items: stretch !important;
    justify-content: stretch !important;
    min-height: 0;
    overflow: hidden;
    padding: 10px !important;
  }
  .chatbot-start-inspection {
    width: 100% !important;
    max-width: none !important;
    height: 100%;
    min-width: 0 !important;
    min-height: 0;
    flex: 1 1 auto !important;
  }
  .chatbot-start-history {
    display: none !important;
  }
  .chatbot-start-card {
    border-radius: 10px !important;
    max-height: none !important;
  }
  .chatbot-start-card > div:first-child,
  .chatbot-start-body {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .chatbot-start-card > div:first-child {
    padding-top: 14px !important;
    padding-bottom: 14px !important;
  }
  .chatbot-start-body {
    padding-top: 14px !important;
    padding-bottom: 14px !important;
  }
  .chatbot-history-open-button {
    min-height: 34px;
  }
  .chatbot-history-modal {
    align-items: center !important;
    padding: 8px !important;
  }
  .chatbot-history-dialog {
    min-height: 0;
    max-height: calc(100dvh - 16px);
    border-radius: 10px !important;
  }
  .chatbot-history-header,
  .chatbot-history-toolbar {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .chatbot-history-header {
    align-items: flex-start;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  .chatbot-start-inspection p,
  .chatbot-start-inspection span,
  .chatbot-history-dialog span,
  .chatbot-history-dialog button {
    word-break: keep-all;
  }
  .report-source-toolbar {
    align-items: stretch;
    flex-direction: column;
    gap: 0;
    padding: 0 0 10px;
  }
  .report-source-actions {
    width: 100%;
    flex-wrap: wrap;
    padding: 0 12px;
  }
  .report-source-scope {
    width: 100%;
    flex: 1 1 100%;
  }
  .report-source-scope-button {
    min-width: 0;
    flex: 1 1 50%;
  }
  .report-source-action {
    flex: 1 1 0;
  }
  .report-source-quota {
    flex: 1 0 100%;
  }
  .report-source-folder-row,
  .report-source-document-row {
    padding-right: 12px;
    padding-left: 12px;
  }
  .report-source-folder-meta {
    gap: 0;
  }
  .report-source-size,
  .report-source-document-size {
    display: none;
  }
  .report-evaluation-button {
    width: 100%;
  }
  .legacy-roomy-controls {
    align-items: stretch !important;
    justify-content: stretch !important;
    overflow: hidden;
    padding: 10px !important;
  }
  .legacy-roomy-controls > div:first-child {
    width: 100% !important;
    max-width: none !important;
    min-width: 0 !important;
    height: 100%;
    min-height: 0;
    overflow-y: auto;
  }
  .legacy-roomy-controls input,
  .legacy-roomy-controls button {
    max-width: 100%;
  }
}
.inspection-guide-layer {
  position: fixed;
  z-index: 10050;
  inset: 0;
  pointer-events: none;
}

.inspection-guide-spotlight {
  position: fixed;
  box-sizing: border-box;
  background: transparent;
  border: 2px solid #60a5fa;
  border-radius: 10px;
  box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.2), 0 0 0 100vmax rgba(15, 23, 42, 0.68);
  pointer-events: none;
  transition: top 0.18s ease, left 0.18s ease, width 0.18s ease, height 0.18s ease;
}

.inspection-guide-tooltip {
  position: fixed;
  box-sizing: border-box;
  padding: 18px;
  color: #0f172a;
  background: #ffffff;
  border: 1px solid #dbe3ec;
  border-radius: 12px;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.28);
  opacity: 0;
  pointer-events: auto;
  transform: translateY(4px);
  transition: opacity 0.14s ease, transform 0.14s ease;
}

.inspection-guide-tooltip.is-ready {
  opacity: 1;
  transform: translateY(0);
}

.inspection-guide-tooltip::before {
  position: absolute;
  left: 50%;
  width: 12px;
  height: 12px;
  content: "";
  background: #ffffff;
  border: 1px solid #dbe3ec;
  transform: translateX(-50%) rotate(45deg);
}

.inspection-guide-tooltip.is-below::before {
  top: -7px;
  border-right: 0;
  border-bottom: 0;
}

.inspection-guide-tooltip.is-above::before {
  bottom: -7px;
  border-top: 0;
  border-left: 0;
}

.inspection-guide-tooltip-header,
.inspection-guide-tooltip-header > div,
.inspection-guide-tooltip-footer,
.inspection-guide-progress {
  display: flex;
  align-items: center;
}

.inspection-guide-tooltip-header {
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.inspection-guide-tooltip-header > div {
  gap: 8px;
}

.inspection-guide-label {
  color: #2563eb;
  font-size: 11px;
  font-weight: 850;
}

.inspection-guide-count {
  color: #94a3b8;
  font-size: 10px;
  font-weight: 700;
}

.inspection-guide-close {
  width: 28px;
  height: 28px;
  padding: 0;
  color: #64748b;
  font-family: inherit;
  font-size: 20px;
  line-height: 1;
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
}

.inspection-guide-close:hover {
  color: #0f172a;
  background: #f1f5f9;
}

.inspection-guide-tooltip h2 {
  margin: 0;
  color: #0f172a;
  font-size: 17px;
  font-weight: 850;
  line-height: 1.4;
  letter-spacing: -0.025em;
}

.inspection-guide-description {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.6;
}

.inspection-guide-points {
  margin: 10px 0 0;
  padding-left: 18px;
  color: #475569;
  font-size: 11px;
  line-height: 1.55;
}

.inspection-guide-progress {
  gap: 5px;
  margin-top: 15px;
}

.inspection-guide-progress span {
  width: 6px;
  height: 6px;
  background: #cbd5e1;
  border-radius: 999px;
}

.inspection-guide-progress span.is-complete {
  background: #93c5fd;
}

.inspection-guide-progress span.is-active {
  width: 20px;
  background: #2563eb;
}

.inspection-guide-extras {
  margin-top: 14px;
  padding: 11px 12px;
  color: #64748b;
  font-size: 10px;
  line-height: 1.5;
  background: #f8fafc;
  border: 1px solid #dbeafe;
  border-radius: 7px;
}

.inspection-guide-extras > strong {
  display: block;
  margin-bottom: 7px;
  color: #334155;
  font-size: 11px;
}

.inspection-guide-extra-row {
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 7px;
  margin-top: 5px;
  padding: 7px 8px;
  color: #64748b;
  font: inherit;
  line-height: inherit;
  text-align: left;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
}

.inspection-guide-extra-row:hover,
.inspection-guide-extra-row:focus-visible {
  background: #eff6ff;
  border-color: #93c5fd;
  outline: none;
}

.inspection-guide-extra-name {
  min-width: 48px;
  flex: 0 0 48px;
  color: #2563eb;
  font-weight: 800;
}

.inspection-guide-extra-copy {
  flex: 1 1 auto;
  min-width: 0;
}

.inspection-guide-extra-arrow {
  flex: 0 0 auto;
  color: #2563eb;
  font-weight: 800;
}

.inspection-guide-layer.is-retro .inspection-guide-extras {
  border-radius: 1px;
}

.inspection-guide-layer.is-retro .inspection-guide-extra-name {
  color: #003366;
}

.inspection-guide-tooltip-footer {
  justify-content: flex-end;
  gap: 7px;
  margin-top: 15px;
  padding-top: 13px;
  border-top: 1px solid #e2e8f0;
}

.inspection-guide-button {
  min-width: 68px;
  min-height: 34px;
  padding: 7px 13px;
  font-family: inherit;
  font-size: 11px;
  font-weight: 800;
  border-radius: 7px;
  cursor: pointer;
}

.inspection-guide-button.is-secondary {
  color: #475569;
  background: #ffffff;
  border: 1px solid #cbd5e1;
}

.inspection-guide-button.is-primary {
  color: #ffffff;
  background: #2563eb;
  border: 1px solid #1d4ed8;
}

.inspection-guide-layer.is-retro .inspection-guide-spotlight,
.inspection-guide-layer.is-retro .inspection-guide-tooltip,
.inspection-guide-layer.is-retro .inspection-guide-close,
.inspection-guide-layer.is-retro .inspection-guide-button {
  border-radius: 1px;
}

.inspection-guide-layer.is-retro .inspection-guide-spotlight {
  border-color: #66a3d2;
}

.inspection-guide-layer.is-retro .inspection-guide-label {
  color: #003366;
}

.inspection-guide-layer.is-retro .inspection-guide-progress span.is-active,
.inspection-guide-layer.is-retro .inspection-guide-button.is-primary {
  background: #003366;
  border-color: #001a33;
}

@media (max-width: 767px) {
  .inspection-guide-tooltip {
    padding: 15px;
  }
  .inspection-guide-tooltip h2 {
    font-size: 15px;
  }
}
.report-library {
  margin-bottom: 16px;
}

.report-library-search {
  width: 210px;
  max-width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  background: white;
  padding: 5px 8px;
  font: inherit;
  font-size: 11px;
}

.report-library-up {
  display: block;
  width: 100%;
  padding: 7px 14px;
  text-align: left;
  border: 0;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  cursor: pointer;
}

.browse-selection-cart {
  margin: 0 0 12px;
  padding: 12px 14px;
  flex-shrink: 0;
  border-top: 1px solid #edf1f5;
}

.browse-cart-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.browse-cart-heading strong {
  flex: 1;
  font-size: 12px;
  color: #334155;
}

.browse-cart-details summary {
  padding-top: 8px;
  font-size: 11px;
  color: #2563eb;
  cursor: pointer;
}

.browse-cart-list {
  max-height: 160px;
  overflow-y: auto;
}

.browse-cart-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #e2e8f0;
  font-size: 11px;
}

.browse-cart-item > div {
  min-width: 0;
  flex: 1;
}

.browse-cart-item strong, .browse-cart-item div span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.browse-cart-item div span {
  color: #64748b;
  margin-top: 3px;
  font-size: 10px;
}

.browse-cart-item > button {
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 18px;
  cursor: pointer;
  min-width: 28px;
}

@media (max-width: 640px) {
  .report-library-search {
    width: 155px;
  }
}`],
})
export class PageChatbotComponent implements OnInit, OnDestroy {
    public theme: string = 'modern';
    public colorMode: string = 'light';
    public showHistoryModal: boolean = false;
    public showHistoryPanel: boolean = false;
    public isMobileLayout: boolean = false;
    public loading: boolean = false;
    public creating: boolean = false;
    public guideVisible: boolean = false;
    public guideStep: number = 0;
    public guideSupplementaryKey: string = '';
    public guideLayoutReady: boolean = false;
    public guideSpotlight: any = { top: 0, left: 0, width: 0, height: 0 };
    public guideTooltip: any = { top: 0, left: 0, width: 360 };
    public guideTooltipPlacement: string = 'below';
    public readonly guideTotalSteps: number = 5;
    private readonly guideSupplementarySteps: { [key: string]: any } = {
        history: {
            target: 'supplementary-history',
            maxHeight: 160,
            label: '기타 사항 · 검사 이력',
            title: '검사 이력은 여기서 확인하세요',
            description: '이전 검사 세션을 다시 열거나 완료된 검사 보고서를 확인할 수 있습니다.',
            points: [
                '완료된 검사에서는 보고서를 바로 내려받을 수 있습니다.',
            ],
        },
    };
    public readonly guideSteps: any[] = [
        {
            target: 'main-mpro',
            label: 'STEP 1 · M-PRO',
            title: 'M-PRO 또는 개인 Drive를 선택하세요',
            description: 'M-PRO 관련 서류를 사용하거나 개인 Drive에 올린 파일을 이번 평가 자료로 선택합니다.',
            points: [
                '개인 파일은 Drive에 올린 뒤 원하는 평가의 검사 자료로 선택해 사용할 수 있습니다.',
            ],
        },
        {
            target: 'main-file-list',
            maxHeight: 180,
            label: 'STEP 2 · 기준 서류',
            title: '평가할 서류를 고르세요',
            description: '선택한 보관 위치에서 이번 평가에 사용할 서류를 체크합니다.',
            points: [
                '체크를 해제한 파일은 이번 검사의 기준 자료에서 제외됩니다.',
            ],
        },
        {
            target: 'main-evaluate',
            label: 'STEP 3 · 챗봇 진입',
            title: '평가하기를 눌러 챗봇으로 이동하세요',
            description: '선택한 평가 자료가 연결된 챗봇에서 보고서 업로드 안내가 이어집니다.',
            points: [
                '이 안내를 닫은 뒤 강조된 평가하기 버튼을 누르세요.',
            ],
        },
    ];
    private readonly draftStorageKey: string = 'inspection.chatbot.draft.v1';
    private readonly guideDismissUntilStorageKey: string = 'inspection.chatbot.guide.dismissUntil.v2';
    private readonly guideRoomPendingStorageKey: string = 'inspection.chatbot.guide.roomPending.v2';
    private readonly guideLastShownDayStorageKey: string = 'inspection.chatbot.guide.mainLastShownDay.v2';
    private guideLayoutTimer: any = null;
    private readonly colorModeStorageKey: string = 'ui-color-mode';

    // Drive 폴더 선택
    public reportFolder: any = null;
    public reportFiles: any[] = [];
    public selectedReportFileIds: { [key: string]: boolean } = {};
    public browseCart: { [key: string]: any } = {};
    public reportProjectId: string = '';
    public reportProjectName: string = '';
    public reportRootFolder: string = '';
    public reportBrowseFolders: any[] = [];
    public reportBrowseFiles: any[] = [];
    public reportBrowseFolder: string = '';
    public reportBrowseBreadcrumb: any[] = [];
    public reportBrowseLoading: boolean = false;
    public reportBrowseError: string = '';
    public reportBrowseSearch: string = '';
    public reportBrowsePage: number = 1;
    private reportBrowseRequest: number = 0;
    private generalBrowseRequest: number = 0;

    // Drive 브라우저 상태
    public browseFolders: any[] = [];
    public browseFiles: any[] = [];
    public browseCurrentFolder: string = '';
    public browseBreadcrumb: any[] = [];
    public browseDriveScope: string = 'shared';
    public browseDriveView: any = null;
    public browseLoadError: string = '';
    public browsePage: number = 1;
    public browsePageSize: number = 10;
    public readonly reportPageSize: number = 5;

    // Session History
    public sessions: any[] = [];
    public loadingSessions: boolean = false;
    public loadingMoreSessions: boolean = false;
    public hasMoreSessions: boolean = false;
    public sessionPage: number = 1;
    public readonly sessionLimit: number = 30;
    public selectedSessionIds: { [key: string]: boolean } = {};
    public historySelectionMode: boolean = false;
    public dailySessionQuota: any = null;

    private browseLayoutFrame: number = 0;
    private browseLayoutKey: string = '';

    private readonly viewportResizeHandler = () => this.onViewportResize();

    constructor(@Inject( Service) public service: Service) { }

    public async openHistoryModal(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.updateMobileLayout();
        if (this.isMobileLayout) {
            this.showHistoryModal = true;
        } else {
            this.showHistoryModal = false;
            this.showHistoryPanel = true;
        }
        await this.service.render();
    }

    public async closeHistoryModal(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.showHistoryModal = false;
        this.historySelectionMode = false;
        this.selectedSessionIds = {};
        await this.service.render();
    }

    public async ngOnInit() {
        await this.service.init();
        this.updateMobileLayout();
        this.updateBrowsePageSize();
        this.showHistoryPanel = !this.isMobileLayout;
        window.addEventListener('resize', this.viewportResizeHandler);
        this.theme = localStorage.getItem('ui-theme') || 'modern';
        this.applyColorMode(this.storedColorMode(), false);
        await this.service.auth.allow(this.loginRedirect());
        this.restoreDraft();
        this.browseDriveScope = 'shared';
        this.loadingSessions = true;
        await this.service.render();
        // STEP 1을 표시하기 전에 Drive와 잔여 세션 위치를 함께 확정한다.
        await Promise.all([
            this.loadDriveFolder(''),
            this.loadDailySessionQuota(),
        ]);
        await this.openGuideIfNeeded();
        // 무거운 검사 이력 목록은 안내가 안정적으로 열린 뒤 비동기로 불러온다.
        setTimeout(() => {
            this.loadSessions(true);
        }, 0);
    }

    // ========== 사용 안내 ==========

    public get currentGuideStep(): any {
        return this.guideSupplementarySteps[this.guideSupplementaryKey]
            || this.guideSteps[this.guideStep]
            || this.guideSteps[0];
    }

    public get isGuideSupplementary(): boolean {
        return !!this.guideSupplementarySteps[this.guideSupplementaryKey];
    }

    public get isGuideLastStep(): boolean {
        return this.guideStep >= this.guideSteps.length - 1;
    }

    private currentGuideDayKey(): string {
        const now = new Date();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return String(now.getFullYear()) + '-' + month + '-' + day;
    }

    private isGuideTestAccount(): boolean {
        const session = this.service?.auth?.session || {};
        const candidates = [
            session.id,
            session.user_id,
            session.username,
            session.login_id,
            session.email,
            session.name,
        ];
        return candidates.some((value: any) => {
            const normalized = String(value || '').trim().toLowerCase();
            return normalized === 'test2' || normalized.split('@')[0] === 'test2';
        });
    }

    private shouldSkipMainGuideToday(): boolean {
        if (this.isGuideTestAccount()) return false;
        try {
            const dismissedUntil = Number(localStorage.getItem(this.guideDismissUntilStorageKey) || 0);
            if (dismissedUntil > Date.now()) return true;
            if (dismissedUntil > 0) localStorage.removeItem(this.guideDismissUntilStorageKey);
            return localStorage.getItem(this.guideLastShownDayStorageKey) === this.currentGuideDayKey();
        } catch (e) {
            return false;
        }
    }

    private async openGuideIfNeeded() {
        if (this.shouldSkipMainGuideToday()) return;
        if (!this.isGuideTestAccount()) {
            try {
                localStorage.setItem(this.guideLastShownDayStorageKey, this.currentGuideDayKey());
            } catch (e) { }
        }
        this.guideStep = 0;
        this.guideSupplementaryKey = '';
        this.guideVisible = true;
        this.guideLayoutReady = false;
        await this.service.render();
        this.scheduleGuideLayout();
    }

    private scheduleGuideLayout(attempt: number = 0) {
        if (!this.guideVisible) return;
        if (this.guideLayoutTimer) window.clearTimeout(this.guideLayoutTimer);
        this.guideLayoutTimer = window.setTimeout(() => {
            this.guideLayoutTimer = null;
            this.updateGuideLayout(attempt);
        }, attempt === 0 ? 0 : 80);
    }

    private updateGuideLayout(attempt: number = 0) {
        if (!this.guideVisible) return;
        const step = this.currentGuideStep;
        const selector = '[data-guide-target="' + String(step?.target || '') + '"]';
        const target = document.querySelector(selector) as HTMLElement;
        if (!target) {
            if (attempt < 10) this.scheduleGuideLayout(attempt + 1);
            return;
        }

        let rect = target.getBoundingClientRect();
        const viewportWidth = Math.max(320, window.innerWidth || document.documentElement.clientWidth || 0);
        const viewportHeight = Math.max(320, window.innerHeight || document.documentElement.clientHeight || 0);
        if (rect.top < 8 || rect.bottom > viewportHeight - 8) {
            try {
                target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
                rect = target.getBoundingClientRect();
            } catch (e) { }
        }

        const padding = 7;
        const spotlightTop = Math.max(8, rect.top - padding);
        const spotlightLeft = Math.max(8, rect.left - padding);
        const spotlightWidth = Math.max(20, Math.min(viewportWidth - spotlightLeft - 8, rect.width + padding * 2));
        const requestedHeight = step?.maxHeight ? Math.min(rect.height, Number(step.maxHeight)) : rect.height;
        const spotlightHeight = Math.max(20, Math.min(viewportHeight - spotlightTop - 8, requestedHeight + padding * 2));
        this.guideSpotlight = {
            top: spotlightTop,
            left: spotlightLeft,
            width: spotlightWidth,
            height: spotlightHeight,
        };

        const tooltipElement = document.querySelector('.inspection-guide-tooltip') as HTMLElement;
        const tooltipHeight = Math.max(180, Number(tooltipElement?.offsetHeight || 220));
        const tooltipWidth = Math.max(280, Math.min(360, viewportWidth - 24));
        const targetCenter = spotlightLeft + spotlightWidth / 2;
        const tooltipLeft = Math.max(12, Math.min(viewportWidth - tooltipWidth - 12, targetCenter - tooltipWidth / 2));
        const belowTop = spotlightTop + spotlightHeight + 14;
        const aboveTop = spotlightTop - tooltipHeight - 14;
        const useBelow = viewportHeight - belowTop >= tooltipHeight || aboveTop < 12;
        const tooltipTop = useBelow
            ? Math.min(belowTop, viewportHeight - tooltipHeight - 12)
            : Math.max(12, aboveTop);

        this.guideTooltip = { top: Math.max(12, tooltipTop), left: tooltipLeft, width: tooltipWidth };
        this.guideTooltipPlacement = useBelow ? 'below' : 'above';
        this.guideLayoutReady = true;
        this.service.render();
    }

    public async nextGuideStep() {
        if (this.isGuideLastStep) return;
        this.guideSupplementaryKey = '';
        this.guideStep += 1;
        this.guideLayoutReady = false;
        await this.service.render();
        this.scheduleGuideLayout();
    }

    public async previousGuideStep() {
        if (this.guideStep <= 0) return;
        this.guideSupplementaryKey = '';
        this.guideStep -= 1;
        this.guideLayoutReady = false;
        await this.service.render();
        this.scheduleGuideLayout();
    }

    public async openGuideSupplementary(key: string) {
        if (!this.guideSupplementarySteps[key]) return;
        this.guideSupplementaryKey = key;
        this.guideLayoutReady = false;
        await this.service.render();
        this.scheduleGuideLayout();
    }

    public async returnToMainGuide() {
        this.guideSupplementaryKey = '';
        this.guideLayoutReady = false;
        await this.service.render();
        this.scheduleGuideLayout();
    }

    private markRoomGuidePending() {
        try {
            localStorage.setItem(this.guideRoomPendingStorageKey, '1');
        } catch (e) { }
    }

    public async completeMainGuide() {
        this.markRoomGuidePending();
        this.guideVisible = false;
        this.guideSupplementaryKey = '';
        this.guideLayoutReady = false;
        await this.service.render();
    }

    public async closeGuide() {
        this.guideVisible = false;
        this.guideSupplementaryKey = '';
        this.guideLayoutReady = false;
        this.guideStep = 0;
        if (this.guideLayoutTimer) {
            window.clearTimeout(this.guideLayoutTimer);
            this.guideLayoutTimer = null;
        }
        await this.service.render();
    }

    private loginRedirect() {
        const path = `${location.pathname}${location.search}${location.hash}`;
        return `/auth/login?returnTo=${encodeURIComponent(path || '/chatbot')}`;
    }

    public ngOnDestroy() {
        if (this.browseLayoutFrame) window.cancelAnimationFrame(this.browseLayoutFrame);
        window.removeEventListener('resize', this.viewportResizeHandler);
        if (this.guideLayoutTimer) {
            window.clearTimeout(this.guideLayoutTimer);
            this.guideLayoutTimer = null;
        }
    }

    public get historyModalVisible(): boolean {
        return this.showHistoryModal && this.isMobileLayout;
    }

    public get historyPanelVisible(): boolean {
        return !this.isMobileLayout && this.showHistoryPanel;
    }

    private detectMobileLayout(): boolean {
        try {
            return window.matchMedia('(max-width: 767px)').matches;
        } catch (e) {
            return window.innerWidth <= 767;
        }
    }

    private updateMobileLayout(): boolean {
        const next = this.detectMobileLayout();
        const changed = this.isMobileLayout !== next;
        this.isMobileLayout = next;
        return changed;
    }

    public ngAfterViewChecked() {
        const key = [window.innerHeight, window.innerWidth, this.loading, this.reportBrowseLoading,
            this.browsePageTotalItems, this.reportDriveItemCount, this.reportBrowseFolder,
            this.browseSelectedCount, this.browsePage, this.browsePageSize, this.theme,
            this.showHistoryPanel, this.isMobileLayout, this.reportBrowseError, this.reportBrowseSearch].join('|');
        if (key === this.browseLayoutKey) return;
        this.browseLayoutKey = key;
        this.scheduleBrowseLayout();
    }

    public scheduleBrowseLayout() {
        if (this.browseLayoutFrame || typeof window === 'undefined') return;
        this.browseLayoutFrame = window.requestAnimationFrame(() => {
            this.browseLayoutFrame = 0;
            if (this.updateBrowsePageSize()) this.service.render();
        });
    }

    private updateBrowsePageSize(): boolean {
        if (typeof document === 'undefined' || this.loading || this.reportBrowseLoading) return false;
        const body = document.querySelector<HTMLElement>('.chatbot-start-body, .report-start-retro');
        const section = body?.querySelector<HTMLElement>(':scope > .report-source');
        const rows = section?.querySelector<HTMLElement>('.report-source-page-content');
        if (!body || !section || !rows || !body.clientHeight) return false;
        const number = (value: string) => parseFloat(value) || 0;
        const bodyStyle = window.getComputedStyle(body);
        let reserved = number(bodyStyle.paddingTop) + number(bodyStyle.paddingBottom);
        for (const element of Array.from(body.children)) {
            const child = element as HTMLElement;
            const style = window.getComputedStyle(child);
            if (style.display === 'none') continue;
            reserved += child.getBoundingClientRect().height;
            // The evaluation action's auto margin uses leftover space, not content space.
            if (!child.classList.contains('report-evaluation-action')) reserved += number(style.marginTop);
            reserved += number(style.marginBottom);
        }
        reserved -= rows.getBoundingClientRect().height;
        const nextSize = Math.max(5, Math.floor((body.clientHeight - reserved - 2) / 38));
        if (nextSize === this.browsePageSize) return false;
        const firstVisibleIndex = Math.max(0, (this.browsePage - 1) * this.browsePageSize);
        this.browsePageSize = nextSize;
        this.browsePage = Math.max(1, Math.min(Math.floor(firstVisibleIndex / nextSize) + 1, this.browsePageCount));
        return true;
    }

    public get browsePageContentHeight(): number {
        return Math.max(0, Math.min(this.browsePageSize, this.browsePageTotalItems - (this.browsePage - 1) * this.browsePageSize)) * 38;
    }

    private onViewportResize() {
        const modalWasOpen = this.showHistoryModal;
        const layoutChanged = this.updateMobileLayout();
        this.scheduleBrowseLayout();
        if (layoutChanged) {
            this.showHistoryPanel = !this.isMobileLayout;
            this.showHistoryModal = this.isMobileLayout && modalWasOpen;
        }
        if (layoutChanged) this.service.render();
        if (this.guideVisible) this.scheduleGuideLayout();
    }

    private normalizeColorMode(value: any): string {
        return String(value || '').trim().toLowerCase() === 'dark' ? 'dark' : 'light';
    }

    private storedColorMode(): string {
        try {
            return this.normalizeColorMode(localStorage.getItem(this.colorModeStorageKey));
        } catch (e) {
            return 'light';
        }
    }

    private applyColorMode(value: any, persist: boolean = true) {
        const mode = this.normalizeColorMode(value);
        const isDark = mode === 'dark';
        this.colorMode = mode;
        try {
            if (persist) localStorage.setItem(this.colorModeStorageKey, mode);
        } catch (e) { }
        try {
            document.documentElement.classList.toggle('ui-dark', isDark);
            document.documentElement.classList.toggle('ui-light', !isDark);
            document.documentElement.style.colorScheme = mode;
            if (document.body) {
                document.body.classList.toggle('ui-dark', isDark);
                document.body.classList.toggle('ui-light', !isDark);
                document.body.style.colorScheme = mode;
            }
        } catch (e) { }
    }

    public async toggleColorMode(event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.applyColorMode(this.colorMode === 'dark' ? 'light' : 'dark');
        await this.service.render();
    }

    private saveDraft() {
        try {
            if (!this.reportFolder) {
                sessionStorage.removeItem(this.draftStorageKey);
                return;
            }
            sessionStorage.setItem(this.draftStorageKey, JSON.stringify({
                reportFolder: this.reportFolder,
                reportFiles: this.reportFiles || [],
                selectedReportFileIds: this.selectedReportFileIds || {},
                savedAt: Date.now(),
            }));
        } catch (e) { }
    }

    private restoreDraft() {
        try {
            const raw = sessionStorage.getItem(this.draftStorageKey);
            if (!raw) return;
            const draft = JSON.parse(raw);
            if (!draft?.reportFolder) return;
            this.reportFolder = draft.reportFolder;
            this.reportFiles = Array.isArray(draft.reportFiles) ? draft.reportFiles : [];
            this.selectedReportFileIds = draft.selectedReportFileIds || {};
            this.browseCart = {};
            for (const file of this.reportFiles) {
                if (file?.id && this.selectedReportFileIds[file.id]) this.browseCart[file.id] = file;
            }
        } catch (e) { }
    }

    private clearDraft() {
        try {
            sessionStorage.removeItem(this.draftStorageKey);
        } catch (e) { }
    }

    private getErrorMessage(error: any, fallback: string): string {
        if (!error) return fallback;
        if (typeof error === 'string') return error;
        if (error?.data?.message) return error.data.message;
        if (error?.responseJSON?.data?.message) return error.responseJSON.data.message;
        if (error?.responseJSON?.message) return error.responseJSON.message;
        if (error?.message) return error.message;
        try {
            const text = JSON.stringify(error);
            return text && text !== '{}' ? text : fallback;
        } catch (e) {
            return fallback;
        }
    }

    // ========== Session History ==========

    private async loadDailySessionQuota() {
        try {
            const res: any = await wiz.call('get_daily_session_quota');
            if (res.code === 200 && res.data?.quota) {
                this.dailySessionQuota = res.data.quota;
            }
        } catch (e) { }
        await this.service.render();
    }

    public async loadSessions(reset: boolean = true) {
        if (this.loadingSessions && !reset) return;
        if (this.loadingMoreSessions) return;
        const nextPage = reset ? 1 : this.sessionPage + 1;
        if (reset) {
            this.loadingSessions = true;
        } else {
            this.loadingMoreSessions = true;
        }
        await this.service.render();
        try {
            const res: any = await wiz.call('list_sessions', { limit: this.sessionLimit, page: nextPage });
            if (res.code === 200 && res.data?.sessions) {
                const rows = res.data.sessions || [];
                this.sessions = reset ? rows : this.sessions.concat(rows);
                this.dailySessionQuota = res.data.quota || this.dailySessionQuota;
                this.sessionPage = nextPage;
                this.hasMoreSessions = !!res.data?.has_more;
                this.pruneSelectedSessions();
            }
        } catch (e) { }
        this.loadingSessions = false;
        this.loadingMoreSessions = false;
        await this.service.render();
        // 잔여량이 뒤늦게 갱신되더라도 열린 안내를 즉시 새 위치에 맞춘다.
        if (this.guideVisible) this.scheduleGuideLayout();
    }

    public async loadMoreSessions(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        if (!this.hasMoreSessions) return;
        await this.loadSessions(false);
    }

    public stopHistoryButtonEvent(event: Event) {
        event.stopPropagation();
        const anyEvent = event as any;
        if (typeof anyEvent.stopImmediatePropagation === 'function') {
            anyEvent.stopImmediatePropagation();
        }
    }

    public async openSession(session: any) {
        this.service.href(`/chatbot/room/${session.id}`);
    }

    public async handleHistorySessionClick(session: any, event: Event) {
        if (this.historySelectionMode) {
            await this.toggleSessionSelection(session, event);
            return;
        }
        this.openSession(session);
    }

    public getInspectionReportUrl(sessionId: string): string {
        return `/wiz/api/page.chatbot.room/serve_inspection_excel?session_id=${encodeURIComponent(sessionId || '')}`;
    }

    public downloadSessionReport(session: any, event: Event) {
        this.stopHistoryButtonEvent(event);
        if (!session?.id) return;
        window.open(this.getInspectionReportUrl(session.id), '_blank');
    }

    public async deleteSession(session: any, event: Event) {
        this.stopHistoryButtonEvent(event);
        const ok = await this.service.modal.show({
            title: '세션 삭제',
            message: '이 검사 세션을 삭제하시겠습니까?',
            action: '삭제',
            actionBtn: 'error',
        });
        if (!ok) return;
        try {
            const res: any = await wiz.call('delete_session', { session_id: session.id });
            if (res.code === 200) {
                this.sessions = this.sessions.filter((s: any) => s.id !== session.id);
                delete this.selectedSessionIds[session.id];
                if (this.sessions.length === 0) this.historySelectionMode = false;
                await this.service.render();
            } else {
                await this.service.modal.error(res.data?.message || '삭제에 실패했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('삭제에 실패했습니다.');
        }
    }

    public get selectedSessionCount(): number {
        return this.getSelectedSessionIds().length;
    }

    public get selectedReportSessionCount(): number {
        return this.getSelectedReportSessions().length;
    }

    public isSessionSelected(session: any): boolean {
        return !!this.selectedSessionIds[session?.id];
    }

    public areAllSessionsSelected(): boolean {
        const ids = (this.sessions || []).map((s: any) => s.id).filter((id: string) => !!id);
        return ids.length > 0 && ids.every((id: string) => !!this.selectedSessionIds[id]);
    }

    public async toggleSessionSelection(session: any, event: Event) {
        this.stopHistoryButtonEvent(event);
        if (!session?.id) return;
        if (this.selectedSessionIds[session.id]) {
            delete this.selectedSessionIds[session.id];
        } else {
            this.selectedSessionIds[session.id] = true;
        }
        await this.service.render();
    }

    public async toggleAllSessionSelection(event: Event) {
        this.stopHistoryButtonEvent(event);
        if (this.areAllSessionsSelected()) {
            this.selectedSessionIds = {};
            await this.service.render();
            return;
        }
        const selected: { [key: string]: boolean } = {};
        for (const session of this.sessions || []) {
            if (session?.id) selected[session.id] = true;
        }
        this.selectedSessionIds = selected;
        await this.service.render();
    }

    public async enterHistorySelectionMode(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        this.historySelectionMode = true;
        await this.service.render();
    }

    public async exitHistorySelectionMode(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        this.historySelectionMode = false;
        this.selectedSessionIds = {};
        await this.service.render();
    }

    public async clearSessionSelection(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        this.selectedSessionIds = {};
        await this.service.render();
    }

    public async downloadSelectedSessionReports(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        const reportSessions = this.getSelectedReportSessions();
        if (reportSessions.length === 0) {
            await this.service.modal.error('선택한 이력에 받을 결과표가 없습니다.');
            return;
        }
        for (const session of reportSessions) {
            window.open(this.getInspectionReportUrl(session.id), '_blank');
        }
    }

    public async deleteSelectedSessions(event?: Event) {
        if (event) this.stopHistoryButtonEvent(event);
        const ids = this.getSelectedSessionIds();
        if (ids.length === 0) {
            await this.service.modal.error('삭제할 이력을 선택해주세요.');
            return;
        }
        const ok = await this.service.modal.show({
            title: '선택 세션 삭제',
            message: `${ids.length}개 검사 세션을 삭제하시겠습니까?`,
            action: '삭제',
            actionBtn: 'error',
        });
        if (!ok) return;
        try {
            const res: any = await wiz.call('delete_sessions', { session_ids: JSON.stringify(ids) });
            if (res.code === 200) {
                this.sessions = this.sessions.filter((s: any) => ids.indexOf(s.id) < 0);
                this.selectedSessionIds = {};
                this.historySelectionMode = false;
                await this.service.render();
            } else {
                await this.service.modal.error(res.data?.message || '삭제에 실패했습니다.');
            }
        } catch (e) {
            await this.service.modal.error('삭제에 실패했습니다.');
        }
    }

    private getSelectedSessionIds(): string[] {
        const existing = new Set((this.sessions || []).map((s: any) => s.id).filter((id: string) => !!id));
        return Object.keys(this.selectedSessionIds || {}).filter((id: string) => this.selectedSessionIds[id] && existing.has(id));
    }

    private getSelectedReportSessions(): any[] {
        const ids = this.getSelectedSessionIds();
        return (this.sessions || []).filter((session: any) => ids.indexOf(session.id) >= 0 && session.has_results);
    }

    private pruneSelectedSessions() {
        const selected: { [key: string]: boolean } = {};
        for (const id of this.getSelectedSessionIds()) {
            selected[id] = true;
        }
        this.selectedSessionIds = selected;
        if ((this.sessions || []).length === 0) {
            this.historySelectionMode = false;
        }
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        try {
            const d = new Date(dateStr);
            const now = new Date();
            const diffMs = now.getTime() - d.getTime();
            const diffMin = Math.floor(diffMs / 60000);
            const diffHour = Math.floor(diffMs / 3600000);
            const diffDay = Math.floor(diffMs / 86400000);
            if (diffMin < 1) return '방금 전';
            if (diffMin < 60) return `${diffMin}분 전`;
            if (diffHour < 24) return `${diffHour}시간 전`;
            if (diffDay < 7) return `${diffDay}일 전`;
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            const hh = String(d.getHours()).padStart(2, '0');
            const mi = String(d.getMinutes()).padStart(2, '0');
            return `${mm}/${dd} ${hh}:${mi}`;
        } catch { return dateStr; }
    }

    public getFileTypeSummary(fileTypes: any): string {
        const labels: any = {
            report: '보고서', reference: '전차', kickoff: '착수계',
            contract: '계약서', ledger: '관리대장', additional: '추가',
        };
        return Object.entries(fileTypes || {})
            .map(([k, v]) => `${labels[k] || k} ${v}`)
            .join(', ');
    }

    public getSessionTitle(session: any): string {
        return session?.service_name || session?.report_folder_name || session?.filenames?.[0] || '검사 세션';
    }

    public getSessionSummary(session: any): string {
        return session?.conversation_summary || session?.first_question || '대화 요약이 없습니다';
    }

    private quotaNumber(value: any): number {
        const num = Number(value);
        return Number.isFinite(num) ? num : 0;
    }

    public get isDailySessionQuotaVisible(): boolean {
        return !!this.dailySessionQuota && this.dailySessionQuota.limited !== false;
    }

    public get isDailySessionQuotaExceeded(): boolean {
        return this.isDailySessionQuotaVisible && this.dailySessionQuota.allowed === false;
    }

    public get dailySessionQuotaText(): string {
        if (!this.isDailySessionQuotaVisible) return '';
        const used = this.quotaNumber(this.dailySessionQuota.used);
        const limit = this.quotaNumber(this.dailySessionQuota.limit);
        const remaining = Math.max(0, this.quotaNumber(this.dailySessionQuota.remaining));
        return `오늘 세션 ${used}/${limit} · 남은 ${remaining}개`;
    }

    public get dailySessionRemainingText(): string {
        if (!this.isDailySessionQuotaVisible) return '';
        const remaining = Math.max(0, this.quotaNumber(this.dailySessionQuota.remaining));
        return `오늘 남은 세션 ${remaining}개`;
    }

    public get dailySessionQuotaNotice(): string {
        if (!this.isDailySessionQuotaExceeded) return '';
        return this.dailySessionQuota?.message || '오늘 만들 수 있는 검사 세션을 모두 사용했습니다.';
    }

    public canStartInspection(): boolean {
        return this.reportFiles.length > 0 && !this.isDailySessionQuotaExceeded && !this.creating;
    }

    // ========== Drive Browse ==========

    public get isBrowseSharedDrive(): boolean {
        return this.browseDriveScope === 'shared';
    }

    public get browseCurrentFolderLabel(): string {
        if (this.browseBreadcrumb.length > 0) {
            return this.browseBreadcrumb[this.browseBreadcrumb.length - 1].name || '';
        }
        return this.isBrowseSharedDrive ? 'M-PRO 관련 서류' : '개인 드라이브';
    }

    public get browseCanSelectCurrentFolder(): boolean {
        return this.browseSelectedCount > 0;
    }

    public get browseEmptyMessage(): string {
        if (this.browseBreadcrumb.length === 0) {
            return this.isBrowseSharedDrive
                ? 'M-PRO에 등록된 서류가 없습니다.'
                : '개인 Drive에 등록된 서류가 없습니다.';
        }
        return '등록된 관련 서류가 없습니다.';
    }

    public get hasEvaluationDocuments(): boolean {
        // 폴더와 페이지를 이동해도 장바구니의 체크된 파일을 평가 자료로 사용한다.
        return this.browseCanSelectCurrentFolder;
    }

    public async setBrowseDriveScope(scope: string) {
        const nextScope = scope === 'personal' ? 'personal' : 'shared';
        if (this.loading || nextScope === this.browseDriveScope) return;

        this.browseDriveScope = nextScope;
        this.browseDriveView = null;
        this.browseCurrentFolder = '';
        this.browseBreadcrumb = [];
        await this.loadDriveFolder('');
    }

    private withBrowseSource(files: any[], folderId: string, trail: any[], scope: string): any[] {
        const name = trail[trail.length - 1]?.name || (scope === 'shared' ? 'M-PRO 관련 서류' : '개인 Drive');
        return (files || []).map((file: any) => ({ ...file,
            source_scope: scope,
            source_folder: { id: folderId, name, path: trail.map((item: any) => item.name).join(' / ') || name },
        }));
    }

    private refreshBrowseCart(files: any[]) {
        for (const file of files) {
            if (this.browseCart[file.id]) this.browseCart[file.id] = { ...this.browseCart[file.id], ...file };
        }
        this.syncBrowseCartDraft();
    }

    public async loadDriveFolder(folderId: string) {
        const request = ++this.generalBrowseRequest;
        this.resetReportContext();
        this.loading = true;
        this.browseLoadError = '';
        await this.service.render();
        try {
            const res: any = await wiz.call('drive_list', { folder_id: folderId, scope: this.browseDriveScope });
            if (request !== this.generalBrowseRequest) return;
            if (res.code !== 200) throw new Error(res.data?.message || 'Drive 목록을 불러오지 못했습니다.');
            const data = res.data || {};
            this.browseCurrentFolder = data.current_folder || '';
            this.browseBreadcrumb = data.breadcrumb || [];
            this.browseDriveView = data.drive_view || null;
            this.browseDriveScope = this.browseDriveView?.scope === 'shared' ? 'shared' : 'personal';
            const inReports = this.isBrowseSharedDrive && this.browseBreadcrumb.length >= 2
                && String(this.browseBreadcrumb[1]?.id || '').startsWith('mprof')
                && String(this.browseBreadcrumb[1]?.name || '').toLowerCase() === 'reports';
            if (inReports) {
                await this.loadDriveFolder(String(this.browseBreadcrumb[0]?.id || ''));
                return;
            }
            this.browseFolders = (data.folders || []).filter((folder: any) => !(this.isBrowseSharedDrive
                && this.browseBreadcrumb.length === 1 && String(folder?.id || '').startsWith('mprof')
                && String(folder?.name || '').toLowerCase() === 'reports'));
            this.browseFiles = this.withBrowseSource(data.files, this.browseCurrentFolder, this.browseBreadcrumb, this.browseDriveScope);
            this.browsePage = 1;
            this.refreshBrowseCart(this.browseFiles);
            await this.loadProjectReports(data.folders || [], request);
        } catch (e) {
            if (request !== this.generalBrowseRequest) return;
            this.browseFolders = [];
            this.browseFiles = [];
            this.browseLoadError = this.getErrorMessage(e, 'Drive 목록을 불러오지 못했습니다.');
        } finally {
            if (request === this.generalBrowseRequest) {
                this.loading = false;
                await this.service.render();
            }
        }
    }

    private resetReportContext() {
        this.reportBrowseRequest++;
        this.reportProjectId = '';
        this.reportProjectName = '';
        this.reportRootFolder = '';
        this.reportBrowseFolder = '';
        this.reportBrowseFolders = [];
        this.reportBrowseFiles = [];
        this.reportBrowseBreadcrumb = [];
        this.reportBrowseSearch = '';
        this.reportBrowsePage = 1;
        this.reportBrowseError = '';
        this.reportBrowseLoading = false;
    }

    private async loadProjectReports(folders: any[], generalRequest: number) {
        if (!this.isBrowseSharedDrive || !this.browseBreadcrumb.length) return;
        const project = this.browseBreadcrumb[0];
        this.reportProjectId = String(project.id || '');
        this.reportProjectName = String(project.name || '');
        this.reportBrowseLoading = true;
        await this.service.render();
        try {
            let reportFolder: any;
            if (this.browseBreadcrumb.length === 1) {
                reportFolder = folders.find((folder: any) => String(folder?.id || '').startsWith('mprof')
                    && String(folder?.name || '').toLowerCase() === 'reports');
            } else {
                const res: any = await wiz.app('data.mpro.reports').call('drive_report_list', { folder_id: '' });
                if (generalRequest !== this.generalBrowseRequest) return;
                if (res.code !== 200) throw new Error(res.data?.message || '보고서 자료를 불러오지 못했습니다.');
                reportFolder = (res.data?.folders || []).find((folder: any) => folder.project_id === this.reportProjectId);
            }
            if (generalRequest !== this.generalBrowseRequest) return;
            this.reportRootFolder = String(reportFolder?.id || '');
            if (this.reportRootFolder) await this.loadReportDrive(this.reportRootFolder);
        } catch (e) {
            if (generalRequest === this.generalBrowseRequest) this.reportBrowseError = this.getErrorMessage(e, '보고서 자료를 불러오지 못했습니다.');
        } finally {
            if (generalRequest === this.generalBrowseRequest) {
                this.reportBrowseLoading = false;
                await this.service.render();
            }
        }
    }

    public async loadReportDrive(folderId: string = '') {
        folderId = folderId || this.reportRootFolder;
        if (!this.reportProjectId || !this.reportRootFolder || !folderId) return;
        const request = ++this.reportBrowseRequest;
        this.reportBrowseLoading = true;
        this.reportBrowseError = '';
        this.reportBrowseFolders = [];
        this.reportBrowseFiles = [];
        await this.service.render();
        try {
            const res: any = await wiz.app('data.mpro.reports').call('drive_report_list', { folder_id: folderId });
            if (request !== this.reportBrowseRequest) return;
            if (res.code !== 200) throw new Error(res.data?.message || '보고서 자료를 불러오지 못했습니다.');
            const data = res.data || {};
            this.reportBrowseFolder = data.current_folder || '';
            this.reportBrowseBreadcrumb = data.breadcrumb || [];
            this.reportBrowseFolders = data.folders || [];
            this.reportBrowseFiles = this.withBrowseSource(data.files, this.reportBrowseFolder,
                data.source_breadcrumb || this.reportBrowseBreadcrumb, 'shared');
            this.reportBrowsePage = 1;
            this.refreshBrowseCart(this.reportBrowseFiles);
        } catch (e) {
            if (request === this.reportBrowseRequest) this.reportBrowseError = this.getErrorMessage(e, '보고서 자료를 불러오지 못했습니다.');
        } finally {
            if (request === this.reportBrowseRequest) {
                this.reportBrowseLoading = false;
                await this.service.render();
            }
        }
    }

    public async reportDriveNavigate(folderId: string = '') {
        this.reportBrowseSearch = '';
        await this.loadReportDrive(folderId);
    }

    public async reportDriveUp() {
        const trail = this.reportBrowseBreadcrumb;
        await this.reportDriveNavigate(trail.length >= 2 ? String(trail[trail.length - 2]?.id || this.reportRootFolder) : this.reportRootFolder);
    }

    private get reportDriveItems(): any[] {
        const query = this.reportBrowseSearch.trim().toLowerCase();
        return [...this.reportBrowseFolders.map((item: any) => ({kind: 'folder', item})),
            ...this.reportBrowseFiles.filter((file: any) => this.isInspectableFile(file)).map((item: any) => ({kind: 'file', item}))]
            .filter((entry: any) => String(entry.item.name || '').toLowerCase().includes(query));
    }

    public get reportDrivePageCount(): number { return Math.max(1, Math.ceil(this.reportDriveItems.length / this.reportPageSize)); }
    public get reportDriveItemCount(): number { return this.reportDriveItems.length; }
    public get reportDriveVisibleFolders(): any[] { return this.reportDrivePageItems.filter((entry: any) => entry.kind === 'folder').map((entry: any) => entry.item); }
    public get reportDriveVisibleFiles(): any[] { return this.reportDrivePageItems.filter((entry: any) => entry.kind === 'file').map((entry: any) => entry.item); }
    private get reportDrivePageItems(): any[] {
        const page = Math.min(this.reportBrowsePage, this.reportDrivePageCount);
        return this.reportDriveItems.slice((page - 1) * this.reportPageSize, page * this.reportPageSize);
    }
    public async setReportDrivePage(page: number) {
        this.reportBrowsePage = Math.max(1, Math.min(page, this.reportDrivePageCount));
        await this.service.render();
    }
    public async searchReportDrive() { this.reportBrowsePage = 1; await this.service.render(); }

    public get browseCartFiles(): any[] { return this.getSelectedBrowseFiles(); }
    private syncBrowseCartDraft() {
        this.reportFiles = this.getSelectedBrowseFiles();
        const first = this.reportFiles[0];
        this.reportFolder = first ? {
            id: first.source_folder?.id || '',
            name: first.source_folder?.name || '선택한 자료',
            drive_view_scope: first.source_scope || 'shared',
            readonly: first.source_scope !== 'personal',
        } : null;
        this.saveDraft();
    }
    private setBrowseCartFile(file: any, checked: boolean) {
        if (!file?.id) return;
        if (checked && this.isInspectableFile(file)) {
            this.selectedReportFileIds[file.id] = true;
            this.browseCart[file.id] = file;
        } else {
            delete this.selectedReportFileIds[file.id];
            delete this.browseCart[file.id];
        }
        this.syncBrowseCartDraft();
    }
    public async removeBrowseCartFile(file: any) {
        this.setBrowseCartFile(file, false);
        await this.service.render();
    }

    public async browseNavigate(folderId: string) {
        await this.loadDriveFolder(folderId);
    }

    public async browseGoRoot() {
        await this.loadDriveFolder('');
    }

    public async refreshBrowseFolder() {
        await this.loadDriveFolder(this.browseCurrentFolder || '');
    }

    public isMissingFile(file: any): boolean {
        return !!file && (file.missing_on_disk === true || file.disk_exists === false || file.downloadable === false);
    }

    private async showMissingDriveFiles(files: any[]) {
        const firstName = files[0]?.name || '선택한 파일';
        const suffix = files.length > 1 ? ` 외 ${files.length - 1}개` : '';
        await this.service.modal.show({
            title: '원본 파일 없음',
            message: `${firstName}${suffix}의 원본 파일이 서버 디스크에 없습니다. 프로젝트 복사 시 data/drive 폴더가 함께 복사되지 않은 것 같습니다. 파일을 다시 업로드해주세요.`,
            action: '확인',
            cancel: false,
            status: 'warning',
        });
    }

    public reportFileExtension(file: any): string {
        const name = String(file?.name || file?.filename || '');
        const extension = name.includes('.') ? name.split('.').pop() : '';
        return String(extension || 'FILE').toUpperCase();
    }

    public get browseReportFiles(): any[] {
        return this.browseFiles.filter((file: any) => this.isInspectableFile(file));
    }

    private getBrowsePageItems(): any[] {
        const items = [
            ...this.browseFolders.map((folder: any) => ({ kind: 'folder', item: folder })),
            ...this.browseReportFiles.map((file: any) => ({ kind: 'file', item: file })),
        ];
        const start = (this.browsePage - 1) * this.browsePageSize;
        return items.slice(start, start + this.browsePageSize);
    }

    public get browseVisibleFolders(): any[] {
        return this.getBrowsePageItems()
            .filter((entry: any) => entry.kind === 'folder')
            .map((entry: any) => entry.item);
    }

    public get browseVisibleReportFiles(): any[] {
        return this.getBrowsePageItems()
            .filter((entry: any) => entry.kind === 'file')
            .map((entry: any) => entry.item);
    }

    public get browsePageTotalItems(): number {
        return this.browseFolders.length + this.browseReportFiles.length;
    }

    public get browsePageCount(): number {
        return Math.max(1, Math.ceil(this.browsePageTotalItems / this.browsePageSize));
    }

    public get browsePageRangeText(): string {
        if (this.browsePageTotalItems === 0) return '0 / 0';
        const start = (this.browsePage - 1) * this.browsePageSize + 1;
        const end = Math.min(this.browsePage * this.browsePageSize, this.browsePageTotalItems);
        return `${start}-${end} / ${this.browsePageTotalItems}`;
    }

    public async setBrowsePage(page: number) {
        const nextPage = Math.max(1, Math.min(Math.trunc(page || 1), this.browsePageCount));
        if (nextPage === this.browsePage) return;
        this.browsePage = nextPage;
        await this.service.render();
    }

    public isInspectableFile(file: any): boolean {
        if (this.isMissingFile(file)) return false;
        const extension = this.reportFileExtension(file);
        return ['PDF', 'HWP', 'HWPX', 'XLSX', 'XLSM'].includes(extension);
    }

    private normalizeBrowseFileRole(value: any): string {
        const raw = String(value || '').trim().toLowerCase();
        const compact = raw.replace(/[\s_-]+/g, '');
        const roleMap: any = {
            report: 'report',
            '보고서': 'report',
            reference: 'reference',
            previous: 'reference',
            '전차': 'reference',
            '전차보고서': 'reference',
            contract: 'contract',
            '계약서': 'contract',
            kickoff: 'kickoff',
            '착수계': 'kickoff',
            ledger: 'ledger',
            '관리대장': 'ledger',
            additional: 'additional',
            other: 'additional',
            '기타': 'additional',
        };
        return roleMap[raw] || roleMap[compact] || '';
    }

    public getBrowseFileRole(file: any): string {
        const name = String(file?.name || file?.filename || '').toLowerCase();
        // 핵심 서류명은 오래된 M-Pro 메타데이터보다 우선한다.
        if (/착수/.test(name)) return 'kickoff';
        if (/시설물.?관리.?대장|관리.?대장/.test(name)) return 'ledger';
        if (/계약/.test(name)) return 'contract';

        const explicitRole = this.normalizeBrowseFileRole(
            file?.recommended_type || file?.role || file?.file_type || file?.type
        );
        if (explicitRole) return explicitRole;

        const extension = this.reportFileExtension(file);
        if (extension === 'XLSX' || extension === 'XLSM') return 'ledger';
        if (/보고서|점검|진단|검토|성능평가/.test(name)) return 'report';
        if (/전차|전년도|이전.?보고서|reference/.test(name)) return 'reference';
        return 'additional';
    }

    public getBrowseFileRoleLabel(file: any): string {
        const labels: any = {
            report: '보고서',
            reference: '전차보고서',
            contract: '계약서',
            kickoff: '착수계',
            ledger: '관리대장',
            additional: '기타자료',
        };
        return labels[this.getBrowseFileRole(file)] || '기타자료';
    }

    private getSelectedBrowseFiles(): any[] {
        return Object.values(this.browseCart).filter((file: any) => this.isBrowseFileSelected(file));
    }

    public get browsePdfCount(): number {
        return this.browseFiles.filter((file: any) => this.isInspectableFile(file)).length;
    }

    public get browseSelectedCount(): number {
        return this.getSelectedBrowseFiles().length;
    }

    public get browseCoreSupportingCount(): number {
        return this.browseFiles.filter((file: any) =>
            this.isInspectableFile(file)
            && ['contract', 'kickoff', 'ledger'].includes(this.getBrowseFileRole(file))
        ).length;
    }

    public isBrowseFileSelected(file: any): boolean {
        return !!file?.id && this.selectedReportFileIds[file.id] === true;
    }

    public async selectBrowseCoreSupportingFiles() {
        for (const file of this.browseFiles) {
            if (this.isInspectableFile(file) && ['contract', 'kickoff', 'ledger'].includes(this.getBrowseFileRole(file))) {
                this.setBrowseCartFile(file, true);
            }
        }
        await this.service.render();
    }

    public async clearBrowseFileSelection() {
        this.selectedReportFileIds = {};
        this.browseCart = {};
        this.syncBrowseCartDraft();
        await this.service.render();
    }

    public async toggleBrowseFile(file: any, event: Event) {
        this.setBrowseCartFile(file, !!(event.target as HTMLInputElement).checked);
        await this.service.render();
    }

    public async selectCurrentFolder() {
        const selectedFiles = this.getSelectedBrowseFiles();
        if (selectedFiles.length === 0) {
            await this.service.modal.show({
                title: '검사 파일 없음',
                message: '검사할 PDF/HWP/HWPX/Excel 파일을 한 개 이상 담아주세요.',
                action: '확인',
                cancel: false,
                status: 'warning',
            });
            return;
        }
        this.syncBrowseCartDraft();
        await this.service.render();
    }

    public async removeReportFile(file: any, event?: Event) {
        if (event) event.stopPropagation();
        await this.removeBrowseCartFile(file);
    }

    public async toggleSelectedReportFile(file: any, event: Event) {
        await this.toggleBrowseFile(file, event);
    }

    public formatSize(bytes: number): string {
        if (!bytes) return '0 B';
        if (bytes < 1024) return bytes + 'B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + 'KB';
        if (bytes < 1073741824) return (bytes / 1048576).toFixed(1) + 'MB';
        return (bytes / 1073741824).toFixed(1) + 'GB';
    }


    // ========== Start Inspection ==========

    public async startEvaluation() {
        if (this.creating || this.isDailySessionQuotaExceeded) return;
        if (this.guideVisible) {
            this.markRoomGuidePending();
            this.guideVisible = false;
            this.guideLayoutReady = false;
        }

        if (this.browseCanSelectCurrentFolder) {
            await this.selectCurrentFolder();
            if (this.reportFolder && this.reportFiles.length > 0) {
                await this.startInspection();
                return;
            }
        }

        // 체크된 파일이 0개면 과거 draft/reportFiles를 재사용하지 않는다.
        this.reportFolder = null;
        this.reportFiles = [];
        this.clearDraft();
        await this.startWithoutRelatedDocuments();
    }

    public async startWithoutRelatedDocuments() {
        if (this.creating) return;
        if (this.isDailySessionQuotaExceeded) {
            await this.service.render();
            return;
        }

        this.creating = true;
        await this.service.render();

        try {
            const res: any = await wiz.call('create_without_documents');
            if (res.code === 200 && res.data?.session_id) {
                this.clearDraft();
                this.service.href(`/chatbot/room/${res.data.session_id}`);
                return;
            }
            await this.service.modal.show({
                title: '평가 시작 실패',
                message: res.data?.message || '평가 세션을 만들지 못했습니다.',
                action: '확인',
                cancel: false,
                status: 'error',
            });
        } catch (e: any) {
            await this.service.modal.show({
                title: '평가 시작 실패',
                message: this.getErrorMessage(e, '평가 세션을 만들지 못했습니다.'),
                action: '확인',
                cancel: false,
                status: 'error',
            });
        }

        this.creating = false;
        await this.service.render();
    }

    public async startInspection() {
        if (!this.reportFolder || this.creating) return;
        if (this.isDailySessionQuotaExceeded) {
            await this.service.render();
            return;
        }
        if (this.reportFiles.length === 0) {
            await this.service.modal.show({
                title: '검사 파일 없음',
                message: '검사할 파일을 한 개 이상 선택해주세요.',
                action: '확인',
                cancel: false,
                status: 'warning',
            });
            return;
        }

        const missingFiles = this.reportFiles.filter((file: any) => this.isMissingFile(file));
        if (missingFiles.length > 0) {
            await this.showMissingDriveFiles(missingFiles);
            return;
        }

        this.creating = true;
        await this.service.render();

        try {
            const reportFileIds = this.reportFiles.map((file: any) => file.id);
            const reportFileRoles = this.reportFiles.reduce((roles: any, file: any) => {
                if (file?.id) roles[String(file.id)] = this.getBrowseFileRole(file);
                return roles;
            }, {});

            const res: any = await wiz.call('create_from_drive_v2', {
                report_folder_id: this.reportFolder.id,
                report_folder_name: this.reportFolder.name,
                report_file_ids: JSON.stringify(reportFileIds),
                report_file_roles: JSON.stringify(reportFileRoles),
            });

            if (res.code === 200 && res.data?.session_id) {
                this.clearDraft();
                this.service.href(`/chatbot/room/${res.data.session_id}`);
                return;
            }

            await this.service.modal.show({
                title: '검사 시작 실패',
                message: res.data?.message || '검사 세션을 만들지 못했습니다.',
                action: '확인',
                cancel: false,
                status: 'error',
            });
        } catch (e: any) {
            await this.service.modal.show({
                title: '검사 시작 실패',
                message: this.getErrorMessage(e, '검사 세션을 만들지 못했습니다.'),
                action: '확인',
                cancel: false,
                status: 'error',
            });
        }

        this.creating = false;
        await this.service.render();
    }
}

export default PageChatbotComponent;